module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderOptions.isOrderShow),
      expression: "orderOptions.isOrderShow"
    }],
    staticClass: "sm-order"
  }, [(_vm.ifFail) ? _c('div', {
    staticClass: "sm-order-content success fail"
  }, [_c('i', {
    staticClass: "bk-icon icon-close",
    on: {
      "click": _vm.closeSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bk-message-box"
  }, [_c('i', {
    staticClass: "bk-icon icon-fail"
  }), _vm._v(" "), _c('p', {
    staticClass: "message big"
  }, [_vm._v("兑换商品出现错误 ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "bk-text-button bk-primary",
    staticStyle: {
      "padding-top": "8px"
    },
    attrs: {
      "title": "继续购买",
      "href": "javascript:"
    },
    on: {
      "click": _vm.closeSuccess
    }
  }, [_vm._v("继续购买 »")])])]) : _vm._e(), _vm._v(" "), (_vm.ifSuccess) ? _c('div', {
    staticClass: "sm-order-content success"
  }, [_c('i', {
    staticClass: "bk-icon icon-close",
    on: {
      "click": _vm.closeSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bk-message-box"
  }, [_c('i', {
    staticClass: "bk-icon icon-success"
  }), _vm._v(" "), _c('p', {
    staticClass: "message big"
  }, [_vm._v("购买成功 " + _vm._s(_vm.shopDetail.title))]), _vm._v(" "), _c('p', {
    staticClass: "message default"
  }, [_vm._v("订单号码： " + _vm._s(_vm.order_id))]), _vm._v(" "), _c('p', {
    staticClass: "message small"
  }, [_vm._v("需要邮寄的物品，将在3个工作日内审核通过并在订单详情中提供邮寄单号，请注意查收！")]), _vm._v(" "), _c('a', {
    staticClass: "bk-text-button bk-primary",
    staticStyle: {
      "padding-top": "8px"
    },
    attrs: {
      "title": "继续购买",
      "href": "javascript:"
    },
    on: {
      "click": _vm.closeSuccess
    }
  }, [_vm._v("继续购买 »")])])]) : _vm._e(), _vm._v(" "), (!_vm.ifFail && !_vm.ifSuccess) ? _c('div', {
    class: ['sm-order-content', {
      'opacity': _vm.opacity
    }]
  }, [_c('i', {
    staticClass: "bk-icon icon-close",
    on: {
      "click": _vm.closeOrder
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sm-order-overflow"
  }, [_c('div', {
    staticClass: "sm-order-white"
  }), _vm._v(" "), _c('div', {
    staticClass: "sm-order-shop"
  }, [_c('div', {
    staticClass: "sm-order-slide"
  }, [_c('div', {
    staticClass: "sm-goods-picture"
  }, [(_vm.curImgIndex === '0' && _vm.shopDetail.logo_list) ? _c('img', {
    attrs: {
      "src": _vm.shopDetail.logo_list[0],
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.curImgUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sm-goods-list"
  }, [_c('a', {
    class: ['bk-icon icon-left', {
      'not-allow': _vm.firstIndex == 0
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.slideLeft
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sm-goods-small"
  }, [_c('transition-group', {
    staticClass: "sm-goods-box",
    attrs: {
      "name": "list",
      "tag": "ul"
    }
  }, _vm._l((_vm.shopDetail.logo_list), function(item, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index >= _vm.firstIndex && index <= _vm.lastIndex),
        expression: "index >= firstIndex && index <= lastIndex"
      }],
      key: item,
      class: ['sm-goods', {
        'active': index == _vm.curImgIndex
      }],
      on: {
        "click": function($event) {
          return _vm.chooseImg(item, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('a', {
    class: ['bk-icon icon-right', {
      'not-allow': _vm.lastIndex == _vm.slideLength - 1
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.slideRight
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sm-order-message"
  }, [_c('div', {
    staticClass: "sm-order-div",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', [_vm._v("商品名称：")]), _vm._v(" "), _c('div', {
    staticClass: "sm-order-item"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.shopDetail.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "sm-order-div",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', [_vm._v("价格：")]), _vm._v(" "), _c('div', {
    staticClass: "sm-order-item"
  }, [_c('div', {
    staticClass: "shop-list-money"
  }, [_vm._v("\n                " + _vm._s(_vm.checkResult.price) + "\n              ")]), _vm._v(" "), ((_vm.priceComputeResult && !_vm.failCode)) ? _c('span', {
    staticClass: "deduct-expenses"
  }, [_vm._v("即将扣除鲸币：" + _vm._s(_vm.priceComputeResult))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.failCode == '40002'),
      expression: "failCode == '40002'"
    }],
    staticClass: "is-danger pl5"
  }, [_vm._v(_vm._s(_vm.failMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "sm-order-div",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', [_vm._v("库存：")]), _vm._v(" "), _c('div', {
    staticClass: "sm-order-item"
  }, [_vm._v("\n              " + _vm._s(_vm.checkResult.amount)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.failCode == '40001'),
      expression: "failCode == '40001'"
    }],
    staticClass: "is-danger pl5"
  }, [_vm._v(_vm._s(_vm.failMessage))])])]), _vm._v(" "), _vm._l((_vm.shopDetail.options), function(oitem, oindex) {
    return (_vm.shopDetail.options) ? _c('div', {
      staticClass: "sm-order-div"
    }, [_c('label', [_vm._v(_vm._s(oitem.text) + "：")]), _vm._v(" "), _c('div', {
      staticClass: "sm-order-item"
    }, _vm._l((oitem.data), function(kitem, kindex) {
      return _c('label', {
        class: ['bk-form-radio', {
          'no-stock': _vm.noStock
        }]
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.option[oindex]),
          expression: "option[oindex]"
        }],
        attrs: {
          "type": "radio",
          "name": oitem.text
        },
        domProps: {
          "value": kitem,
          "checked": _vm._q(_vm.option[oindex], kitem)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.option, oindex, kitem)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "bk-button bk-default bk-radio-text",
        attrs: {
          "title": kitem
        }
      }, [_c('span', [_vm._v(_vm._s(kitem))])])])
    }), 0)]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "sm-order-div"
  }, [_c('label', [_vm._v("说明：")]), _vm._v(" "), _c('div', {
    staticClass: "sm-order-item"
  }, [_c('span', {
    staticClass: "sm-order-dec"
  }, [_vm._v(_vm._s(_vm.shopDetail.desc))])])])], 2)]), _vm._v(" "), _c('div', {
    class: ['shop-content', {
      'virtual': _vm.shopDetail.is_virtual
    }]
  }, [_c('form', {
    staticClass: "bk-form"
  }, [_c('h2', [_vm._v("订单信息")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("收件人：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recipient),
      expression: "recipient"
    }],
    class: ['bk-form-input', {
      'is-danger': _vm.isRecipientNull
    }],
    staticStyle: {
      "width": "305px"
    },
    attrs: {
      "type": "text",
      "name": "validation_name"
    },
    domProps: {
      "value": (_vm.recipient)
    },
    on: {
      "click": _vm.onFocusRecipient,
      "blur": _vm.checkRecipient,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recipient = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isRecipientNull === true) ? _c('span', {
    staticClass: "bk-form-tip recipientTips"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.info.recipientTips))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("所在地区：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('div', {
    staticClass: "select-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.province),
      expression: "info.province"
    }],
    class: ['bk-form-select', {
      'selected': _vm.info.province != -1,
      'initialize': _vm.info.province == -1,
      'is-danger': _vm.info.isProviceNull == true && _vm.info.province == -1
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.info, "province", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateMap('province')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "-1",
      "hidden": ""
    }
  }, [_vm._v("请选择省")]), _vm._v(" "), (_vm.info.provinceList.length > 0) ? _vm._l((_vm.info.provinceList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.provinceID
      }
    }, [_vm._v(_vm._s(item.province))])
  }) : _c('option', [_vm._v("暂无数据")])], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.city),
      expression: "info.city"
    }],
    class: ['bk-form-select', {
      'selected': _vm.info.city != -1,
      'initialize': _vm.info.city == -1,
      'is-danger': _vm.info.isCityNull == true && _vm.info.city == -1
    }],
    attrs: {
      "disabled": _vm.info.province === '-1'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.info, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateMap('city')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "-1",
      "hidden": ""
    }
  }, [_vm._v("请选择市")]), _vm._v(" "), (_vm.info.cityList.length > 0) ? _vm._l((_vm.info.cityList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.cityID
      }
    }, [_vm._v(_vm._s(item.city))])
  }) : _c('option', [_vm._v("暂无数据")])], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.district),
      expression: "info.district"
    }],
    class: ['bk-form-select', {
      'selected': _vm.info.district != -1,
      'initialize': _vm.info.district == -1,
      'is-danger': _vm.info.isDistrictNull == true && _vm.info.district == -1
    }],
    attrs: {
      "disabled": _vm.info.city === '-1'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.info, "district", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateMap('district')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "-1",
      "hidden": ""
    }
  }, [_vm._v("请选择地区")]), _vm._v(" "), (_vm.info.districtList.length > 0) ? _vm._l((_vm.info.districtList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.areaID
      }
    }, [_vm._v(_vm._s(item.area))])
  }) : _vm._e(), _vm._v(" "), (_vm.info.districtList.length == 0) ? _c('option', [_vm._v("全市")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCannot),
      expression: "isCannot"
    }],
    staticClass: "select-group is-danger",
    staticStyle: {
      "padding-left": "130px",
      "padding-top": "5px",
      "font-size": "12px"
    }
  }, [_vm._v("很抱歉，目前邮件地址暂不支持内蒙古和新疆地区，还请谅解！")])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("详细地址：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.detail),
      expression: "info.detail"
    }],
    class: ['bk-form-textarea', {
      'is-danger': _vm.isAddressNull
    }],
    staticStyle: {
      "width": "486px"
    },
    attrs: {
      "placeholder": "请输入详细地址"
    },
    domProps: {
      "value": (_vm.info.detail)
    },
    on: {
      "click": _vm.onFocusAddress,
      "blur": function($event) {
        _vm.updateMap(), _vm.checkValidate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "detail", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.isAddressNull === true) ? _c('span', {
    staticClass: "bk-form-tip addressDetailTip"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.info.tips))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("手机号码：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    class: ['bk-form-input', {
      'is-danger': _vm.isPhoneNull
    }],
    staticStyle: {
      "width": "163px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "blur": _vm.checkPhoneNumber,
      "click": _vm.onFocusPhone,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isPhoneNull === true) ? _c('span', {
    staticClass: "bk-form-tip"
  }, [_vm._v(_vm._s(_vm.info.phoneTips))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item bk-form-action"
  }, [(!_vm.shopDetail.is_virtual) ? _c('label', {
    staticClass: "bk-label"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('a', {
    class: ['bk-button bk-primary', {
      'is-disabled': _vm.failCode !== ''
    }],
    staticStyle: {
      "width": "98px",
      "position": "relative"
    },
    attrs: {
      "title": "确定购买"
    },
    on: {
      "click": function($event) {
        return _vm.buy()
      }
    }
  }, [_c('span', [_vm._v("确定购买")])]), _vm._v(" "), _c('a', {
    staticClass: "bk-button",
    staticStyle: {
      "width": "98px"
    },
    attrs: {
      "title": "取消"
    },
    on: {
      "click": function($event) {
        return _vm.closeOrder()
      }
    }
  }, [_c('span', [_vm._v("取消")])])])])])])])]) : _vm._e(), _vm._v(" "), _c('v-transaction', {
    attrs: {
      "showTradePassword": _vm.showTradePassword
    },
    on: {
      "after-check": _vm.afterCheck,
      "close-box": _vm.closeBox
    }
  }), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.v_options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "message small"
  }, [_vm._v("请联系"), _c('a', {
    attrs: {
      "href": "//wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDgwMjAwMV80NDMwOTZfODAwODAyMDAxXzJf",
      "target": "_blank"
    }
  }, [_vm._v("官方客服")]), _vm._v("反馈该问题")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "bk-form-select"
  }, [_c('option', [_vm._v("中国大陆")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "bk-form-panel"
  }, [_c('select', {
    staticClass: "bk-form-select",
    staticStyle: {
      "width": "132px"
    },
    attrs: {
      "name": "validation_select"
    }
  }, [_c('option', {
    attrs: {
      "value": "beijing"
    }
  }, [_vm._v("中国大陆 +86")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2560b302!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order.vue
// module id = yTtI
// module chunks = 16